import { AxiosPut } from "../useApi";

export function PauseRecording(instanceId, reason, contactId, initialContactId, email) {
    const params = { instanceId };
    const body = { 
        ContactId: contactId,
        InitialContactId: initialContactId,
        Reason: reason,
        User: email
    };
    return AxiosPut('recordings/pause', params, body);
};

export function ResumeRecording(instanceId, contactId, initialContactId, email) {
    const params = { instanceId };
    const body = { 
        ContactId: contactId,
        InitialContactId: initialContactId,
        User: email
    }
    return AxiosPut('recordings/resume', params, body);
}

export function StopRecording(instanceId, reason, contactId, initialContactId, email) { 
    const params = { instanceId };
    const body = { 
        ContactId: contactId,
        InitialContactId: initialContactId,
        Reason: reason,
        User: email
    }
    return AxiosPut('recordings/stop', params, body);
}